import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './styles/global.css';
import { AppProvider } from './app-state';
import { applyTheme, readTheme } from './data/theme';
import { applyUiStyle, readUiStyle } from './data/ui-style';
import { Gateway } from './gateway/Gateway';
import { AppRoutes } from './routes';

applyTheme(readTheme());
applyUiStyle(readUiStyle());

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 0,
      staleTime: 15_000,
    },
  },
});

const container = document.getElementById('root');
if (container === null) {
  throw new Error('Root container #root is missing from index.html');
}

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <Gateway>
        <AppProvider>
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
        </AppProvider>
      </Gateway>
    </QueryClientProvider>
  </StrictMode>,
);
